import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.Offers}-enter {
		.${Layouts.Offers}-background {
			opacity: 0;
		}

		.${Layouts.Offers} {
			opacity: 0;
		}
	}

	&.${Layouts.Offers}-enter-active,
		&.${Layouts.Offers}-enter-done,
		&.${Layouts.Offers}-exit {
		.${Layouts.Offers}-background {
			opacity: 1;
		}

		.${Layouts.Offers} {
			opacity: 1;
		}
	}

	&.${Layouts.Offers}-exit-active {
		.${Layouts.Offers}-background {
			opacity: 0;
		}

		.${Layouts.Offers} {
			opacity: 0;
		}
	}
`;
